<template>
<div class="device" ref="device">
  <div class="screen">
    <TerminalEmulator v-show="currentApp == 'terminal'" :fontColor="this.terminalFontColor" :background="this.terminalBackgroundColor" ref="terminalEmulator"></TerminalEmulator>
  </div>
  <div class="spacer">
  </div>
  <div class="container-fluid keyboardContainer">
  <div class="keyboard" v-if="keyboardType == 1">
    <div class="row keyboardSmallRow justify-content-center">
      <div class="col keycap-sm" v-on:click="keyClick(1)"><div class="mainSymbol-sm">1</div><div class="secondarySymbol-sm">!</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(2)"><div class="mainSymbol-sm">2</div><div class="secondarySymbol-sm">@</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(3)"><div class="mainSymbol-sm">3</div><div class="secondarySymbol-sm">#</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(4)"><div class="mainSymbol-sm">4</div><div class="secondarySymbol-sm">$</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(5)"><div class="mainSymbol-sm">5</div><div class="secondarySymbol-sm">%</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(6)"><div class="mainSymbol-sm">6</div><div class="secondarySymbol-sm">^</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(7)"><div class="mainSymbol-sm">7</div><div class="secondarySymbol-sm">&</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(8)"><div class="mainSymbol-sm">8</div><div class="secondarySymbol-sm">*</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(9)"><div class="mainSymbol-sm">9</div><div class="secondarySymbol-sm">(</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(0)"><div class="mainSymbol-sm">0</div><div class="secondarySymbol-sm">)</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('q')"><div class="mainSymbol">Q</div><div class="secondarySymbol">Й</div></div>
      <div class="col keycap" v-on:click="keyClick('w')"><div class="mainSymbol">W</div><div class="secondarySymbol">Ц</div></div>
      <div class="col keycap" v-on:click="keyClick('e')"><div class="mainSymbol">E</div><div class="secondarySymbol">У</div></div>
      <div class="col keycap" v-on:click="keyClick('r')"><div class="mainSymbol">R</div><div class="secondarySymbol">К</div></div>
      <div class="col keycap" v-on:click="keyClick('t')"><div class="mainSymbol">T</div><div class="secondarySymbol">Е</div></div>
      <div class="col keycap" v-on:click="keyClick('y')"><div class="mainSymbol">Y</div><div class="secondarySymbol">Н</div></div>
      <div class="col keycap" v-on:click="keyClick('u')"><div class="mainSymbol">U</div><div class="secondarySymbol">Г</div></div>
      <div class="col keycap" v-on:click="keyClick('i')"><div class="mainSymbol">I</div><div class="secondarySymbol">Ш</div></div>
      <div class="col keycap" v-on:click="keyClick('o')"><div class="mainSymbol">O</div><div class="secondarySymbol">Щ</div></div>
      <div class="col keycap" v-on:click="keyClick('p')"><div class="mainSymbol">P</div><div class="secondarySymbol">З</div></div>
    </div>

    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('a')"><div class="mainSymbol">A</div><div class="secondarySymbol">Ф</div></div>
      <div class="col keycap" v-on:click="keyClick('s')"><div class="mainSymbol">S</div><div class="secondarySymbol">Ы</div></div>
      <div class="col keycap" v-on:click="keyClick('d')"><div class="mainSymbol">D</div><div class="secondarySymbol">В</div></div>
      <div class="col keycap" v-on:click="keyClick('f')"><div class="mainSymbol">F</div><div class="secondarySymbol">А</div></div>
      <div class="col keycap" v-on:click="keyClick('g')"><div class="mainSymbol">G</div><div class="secondarySymbol">П</div></div>
      <div class="col keycap" v-on:click="keyClick('h')"><div class="mainSymbol">H</div><div class="secondarySymbol">Р</div></div>
      <div class="col keycap" v-on:click="keyClick('j')"><div class="mainSymbol">J</div><div class="secondarySymbol">О</div></div>
      <div class="col keycap" v-on:click="keyClick('k')"><div class="mainSymbol">K</div><div class="secondarySymbol">Л</div></div>
      <div class="col keycap" v-on:click="keyClick('l')"><div class="mainSymbol">L</div><div class="secondarySymbol">Д</div></div>
    </div>

    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('z')"><div class="mainSymbol">Z</div><div class="secondarySymbol">Я</div></div>
      <div class="col keycap" v-on:click="keyClick('x')"><div class="mainSymbol">X</div><div class="secondarySymbol">Ч</div></div>
      <div class="col keycap" v-on:click="keyClick('c')"><div class="mainSymbol">C</div><div class="secondarySymbol">С</div></div>
      <div class="col keycap" v-on:click="keyClick('v')"><div class="mainSymbol">V</div><div class="secondarySymbol">М</div></div>
      <div class="col keycap" v-on:click="keyClick('b')"><div class="mainSymbol">B</div><div class="secondarySymbol">И</div></div>
      <div class="col keycap" v-on:click="keyClick('n')"><div class="mainSymbol">N</div><div class="secondarySymbol">Т</div></div>
      <div class="col keycap" v-on:click="keyClick('m')"><div class="mainSymbol">M</div><div class="secondarySymbol">Ь</div></div>
      <div class="col keycap" v-on:click="keyClick('back')"><div class="mainSymbol">⌫</div><div class="secondarySymbol">back</div></div>
    </div>

    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('ctrl')"><div class="mainSymbol">^</div><div class="secondarySymbol">ctrl</div></div>
      <div class="col keycap" v-on:click="keyClick('space')"><div class="mainSymbol">_</div><div class="secondarySymbol">space</div></div>
      <div class="col keycap" v-on:click="keyClick('left')"><div class="mainSymbol">←</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('right')"><div class="mainSymbol">→</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('up')"><div class="mainSymbol">↑</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('down')"><div class="mainSymbol">↓</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('enter')"><div class="mainSymbol">↵</div><div class="secondarySymbol">enter</div></div>
    </div>
    

  </div>
  <div class="keyboard" v-if="keyboardType == 2">
    <div class="row keyboardSmallRow justify-content-center">
      <div class="col keycap-sm" v-on:click="keyClick(1)" ><div class="mainSymbol-sm">1</div><div class="secondarySymbol-sm">!</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(2)"><div class="mainSymbol-sm">2</div><div class="secondarySymbol-sm">@</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(3)"><div class="mainSymbol-sm">3</div><div class="secondarySymbol-sm">#</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(4)"><div class="mainSymbol-sm">4</div><div class="secondarySymbol-sm">$</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(5)"><div class="mainSymbol-sm">5</div><div class="secondarySymbol-sm">%</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(6)"><div class="mainSymbol-sm">6</div><div class="secondarySymbol-sm">^</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(7)"><div class="mainSymbol-sm">7</div><div class="secondarySymbol-sm">&</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(8)"><div class="mainSymbol-sm">8</div><div class="secondarySymbol-sm">*</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(9)"><div class="mainSymbol-sm">9</div><div class="secondarySymbol-sm">(</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(0)"><div class="mainSymbol-sm">0</div><div class="secondarySymbol-sm">)</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('q')"><div class="mainSymbol">Q</div><div class="secondarySymbol">た</div></div>
      <div class="col keycap" v-on:click="keyClick('w')"><div class="mainSymbol">W</div><div class="secondarySymbol">て</div></div>
      <div class="col keycap" v-on:click="keyClick('e')"><div class="mainSymbol">E</div><div class="secondarySymbol">い</div></div>
      <div class="col keycap" v-on:click="keyClick('r')"><div class="mainSymbol">R</div><div class="secondarySymbol">す</div></div>
      <div class="col keycap" v-on:click="keyClick('t')"><div class="mainSymbol">T</div><div class="secondarySymbol">か</div></div>
      <div class="col keycap" v-on:click="keyClick('y')"><div class="mainSymbol">Y</div><div class="secondarySymbol">ん</div></div>
      <div class="col keycap" v-on:click="keyClick('u')"><div class="mainSymbol">U</div><div class="secondarySymbol">な</div></div>
      <div class="col keycap" v-on:click="keyClick('i')"><div class="mainSymbol">I</div><div class="secondarySymbol">に</div></div>
      <div class="col keycap" v-on:click="keyClick('o')"><div class="mainSymbol">O</div><div class="secondarySymbol">ら</div></div>
      <div class="col keycap" v-on:click="keyClick('p')"><div class="mainSymbol">P</div><div class="secondarySymbol">せ</div></div>
      
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('a')"><div class="mainSymbol">A</div><div class="secondarySymbol">ち</div></div>
      <div class="col keycap" v-on:click="keyClick('s')"><div class="mainSymbol">S</div><div class="secondarySymbol">と</div></div>
      <div class="col keycap" v-on:click="keyClick('d')"><div class="mainSymbol">D</div><div class="secondarySymbol">し</div></div>
      <div class="col keycap" v-on:click="keyClick('f')"><div class="mainSymbol">F</div><div class="secondarySymbol">は</div></div>
      <div class="col keycap" v-on:click="keyClick('g')"><div class="mainSymbol">G</div><div class="secondarySymbol">き</div></div>
      <div class="col keycap" v-on:click="keyClick('h')"><div class="mainSymbol">H</div><div class="secondarySymbol">く</div></div>
      <div class="col keycap" v-on:click="keyClick('j')"><div class="mainSymbol">J</div><div class="secondarySymbol">ま</div></div>
      <div class="col keycap" v-on:click="keyClick('k')"><div class="mainSymbol">K</div><div class="secondarySymbol">の</div></div>
      <div class="col keycap" v-on:click="keyClick('l')"><div class="mainSymbol">L</div><div class="secondarySymbol">れ</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('z')"><div class="mainSymbol">Z</div><div class="secondarySymbol">っ</div></div>
      <div class="col keycap" v-on:click="keyClick('x')"><div class="mainSymbol">X</div><div class="secondarySymbol">さ</div></div>
      <div class="col keycap" v-on:click="keyClick('c')"><div class="mainSymbol">C</div><div class="secondarySymbol">そ</div></div>
      <div class="col keycap" v-on:click="keyClick('v')"><div class="mainSymbol">V</div><div class="secondarySymbol">ひ</div></div>
      <div class="col keycap" v-on:click="keyClick('b')"><div class="mainSymbol">B</div><div class="secondarySymbol">こ</div></div>
      <div class="col keycap" v-on:click="keyClick('n')"><div class="mainSymbol">N</div><div class="secondarySymbol">み</div></div>
      <div class="col keycap" v-on:click="keyClick('m')"><div class="mainSymbol">M</div><div class="secondarySymbol">も</div></div>
      <div class="col keycap" v-on:click="keyClick('back')"><div class="mainSymbol">⌫</div><div class="secondarySymbol">back</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('ctrl')"><div class="mainSymbol">^</div><div class="secondarySymbol">ctrl</div></div>
      <div class="col keycap" v-on:click="keyClick('space')"><div class="mainSymbol">_</div><div class="secondarySymbol">space</div></div>
      <div class="col keycap" v-on:click="keyClick('left')"><div class="mainSymbol">←</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('right')"><div class="mainSymbol">→</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('up')"><div class="mainSymbol">↑</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('down')"><div class="mainSymbol">↓</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('enter')"><div class="mainSymbol">↵</div><div class="secondarySymbol">enter</div></div>
    </div>
  </div>
  <div class="keyboard" v-if="keyboardType == 3">

  <!-- keys - ㅂㅈㄷㄱ쇼ㅕㅑㅐㅔㅁㄴㅇㄹ호ㅓㅏㅣㅋㅌㅊ퓨ㅜㅡ -->
    <div class="row keyboardSmallRow justify-content-center">
      <div class="col keycap-sm" v-on:click="keyClick(1)"><div class="mainSymbol-sm">1</div><div class="secondarySymbol-sm">!</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(2)"><div class="mainSymbol-sm">2</div><div class="secondarySymbol-sm">@</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(3)"><div class="mainSymbol-sm">3</div><div class="secondarySymbol-sm">#</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(4)"><div class="mainSymbol-sm">4</div><div class="secondarySymbol-sm">$</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(5)"><div class="mainSymbol-sm">5</div><div class="secondarySymbol-sm">%</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(6)"><div class="mainSymbol-sm">6</div><div class="secondarySymbol-sm">^</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(7)"><div class="mainSymbol-sm">7</div><div class="secondarySymbol-sm">&</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(8)"><div class="mainSymbol-sm">8</div><div class="secondarySymbol-sm">*</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(9)"><div class="mainSymbol-sm">9</div><div class="secondarySymbol-sm">(</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(0)"><div class="mainSymbol-sm">0</div><div class="secondarySymbol-sm">)</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('q')"><div class="mainSymbol">Q</div><div class="secondarySymbol">ㅂ</div></div>
      <div class="col keycap" v-on:click="keyClick('w')"><div class="mainSymbol">W</div><div class="secondarySymbol">ㅈ</div></div>
      <div class="col keycap" v-on:click="keyClick('e')"><div class="mainSymbol">E</div><div class="secondarySymbol">ㄷ</div></div>
      <div class="col keycap" v-on:click="keyClick('r')"><div class="mainSymbol">R</div><div class="secondarySymbol">ㄱ</div></div>
      <div class="col keycap" v-on:click="keyClick('t')"><div class="mainSymbol">T</div><div class="secondarySymbol">쇼</div></div>
      <div class="col keycap" v-on:click="keyClick('y')"><div class="mainSymbol">Y</div><div class="secondarySymbol">ㅕ</div></div>
      <div class="col keycap" v-on:click="keyClick('u')"><div class="mainSymbol">U</div><div class="secondarySymbol">ㅑ</div></div>
      <div class="col keycap" v-on:click="keyClick('i')"><div class="mainSymbol">I</div><div class="secondarySymbol">ㅐ</div></div>
      <div class="col keycap" v-on:click="keyClick('o')"><div class="mainSymbol">O</div><div class="secondarySymbol">ㅔ</div></div>
      <div class="col keycap" v-on:click="keyClick('p')"><div class="mainSymbol">P</div><div class="secondarySymbol">ㅁ</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('a')"><div class="mainSymbol">A</div><div class="secondarySymbol">ㄴ</div></div>
      <div class="col keycap" v-on:click="keyClick('s')"><div class="mainSymbol">S</div><div class="secondarySymbol">ㅇ</div></div>
      <div class="col keycap" v-on:click="keyClick('d')"><div class="mainSymbol">D</div><div class="secondarySymbol">ㄹ</div></div>
      <div class="col keycap" v-on:click="keyClick('f')"><div class="mainSymbol">F</div><div class="secondarySymbol">호</div></div>
      <div class="col keycap" v-on:click="keyClick('g')"><div class="mainSymbol">G</div><div class="secondarySymbol">ㅓ</div></div>
      <div class="col keycap" v-on:click="keyClick('h')"><div class="mainSymbol">H</div><div class="secondarySymbol">ㅏ</div></div>
      <div class="col keycap" v-on:click="keyClick('j')"><div class="mainSymbol">J</div><div class="secondarySymbol">ㅣ</div></div>
      <div class="col keycap" v-on:click="keyClick('k')"><div class="mainSymbol">K</div><div class="secondarySymbol">ㅋ</div></div>
      <div class="col keycap" v-on:click="keyClick('l')"><div class="mainSymbol">L</div><div class="secondarySymbol">ㅌ</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">

      <div class="col keycap" v-on:click="keyClick('z')"><div class="mainSymbol">Z</div><div class="secondarySymbol">ㅜ</div></div>
      <div class="col keycap" v-on:click="keyClick('x')"><div class="mainSymbol">X</div><div class="secondarySymbol">ㅡ</div></div>
      <div class="col keycap" v-on:click="keyClick('c')"><div class="mainSymbol">C</div><div class="secondarySymbol">ㅋ</div></div>
      <div class="col keycap" v-on:click="keyClick('v')"><div class="mainSymbol">V</div><div class="secondarySymbol">ㅌ</div></div>
      <div class="col keycap" v-on:click="keyClick('b')"><div class="mainSymbol">B</div><div class="secondarySymbol">ㅊ</div></div>
      <div class="col keycap" v-on:click="keyClick('n')"><div class="mainSymbol">N</div><div class="secondarySymbol">ㅟ</div></div>
      <div class="col keycap" v-on:click="keyClick('m')"><div class="mainSymbol">M</div><div class="secondarySymbol">ㅜ</div></div>
      <div class="col keycap" v-on:click="keyClick('back')"><div class="mainSymbol">⌫</div><div class="secondarySymbol">back</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('ctrl')"><div class="mainSymbol">^</div><div class="secondarySymbol">ctrl</div></div>
      <div class="col keycap" v-on:click="keyClick('space')"><div class="mainSymbol">_</div><div class="secondarySymbol">space</div></div>
      <div class="col keycap" v-on:click="keyClick('left')"><div class="mainSymbol">←</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('right')"><div class="mainSymbol">→</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('up')"><div class="mainSymbol">↑</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('down')"><div class="mainSymbol">↓</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('enter')"><div class="mainSymbol">↵</div><div class="secondarySymbol">enter</div></div>
    </div>
  </div>
  <div class="keyboard" v-if="keyboardType == 4">
  <!-- keys - ;ςερτυθιοπασδφγηξκλζχψωβνμ -->
  <div class="row keyboardSmallRow justify-content-center">
      <div class="col keycap-sm" v-on:click="keyClick(1)"><div class="mainSymbol-sm">1</div><div class="secondarySymbol-sm">!</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(2)"><div class="mainSymbol-sm">2</div><div class="secondarySymbol-sm">@</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(3)"><div class="mainSymbol-sm">3</div><div class="secondarySymbol-sm">#</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(4)"><div class="mainSymbol-sm">4</div><div class="secondarySymbol-sm">$</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(5)"><div class="mainSymbol-sm">5</div><div class="secondarySymbol-sm">%</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(6)"><div class="mainSymbol-sm">6</div><div class="secondarySymbol-sm">^</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(7)"><div class="mainSymbol-sm">7</div><div class="secondarySymbol-sm">&</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(8)"><div class="mainSymbol-sm">8</div><div class="secondarySymbol-sm">*</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(9)"><div class="mainSymbol-sm">9</div><div class="secondarySymbol-sm">(</div></div>
      <div class="col keycap-sm" v-on:click="keyClick(0)"><div class="mainSymbol-sm">0</div><div class="secondarySymbol-sm">)</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('q')"><div class="mainSymbol">Q</div><div class="secondarySymbol">;</div></div>
      <div class="col keycap" v-on:click="keyClick('w')"><div class="mainSymbol">W</div><div class="secondarySymbol">ς</div></div>
      <div class="col keycap" v-on:click="keyClick('e')"><div class="mainSymbol">E</div><div class="secondarySymbol">ε</div></div>
      <div class="col keycap" v-on:click="keyClick('r')"><div class="mainSymbol">R</div><div class="secondarySymbol">ρ</div></div>
      <div class="col keycap" v-on:click="keyClick('t')"><div class="mainSymbol">T</div><div class="secondarySymbol">τ</div></div>
      <div class="col keycap" v-on:click="keyClick('y')"><div class="mainSymbol">Y</div><div class="secondarySymbol">υ</div></div>
      <div class="col keycap" v-on:click="keyClick('u')"><div class="mainSymbol">U</div><div class="secondarySymbol">μ</div></div>
      <div class="col keycap" v-on:click="keyClick('i')"><div class="mainSymbol">I</div><div class="secondarySymbol">ι</div></div>
      <div class="col keycap" v-on:click="keyClick('o')"><div class="mainSymbol">O</div><div class="secondarySymbol">ο</div></div>
      <div class="col keycap" v-on:click="keyClick('p')"><div class="mainSymbol">P</div><div class="secondarySymbol">π</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('a')"><div class="mainSymbol">A</div><div class="secondarySymbol">α</div></div>
      <div class="col keycap" v-on:click="keyClick('s')"><div class="mainSymbol">S</div><div class="secondarySymbol">σ</div></div>
      <div class="col keycap" v-on:click="keyClick('d')"><div class="mainSymbol">D</div><div class="secondarySymbol">δ</div></div>
      <div class="col keycap" v-on:click="keyClick('f')"><div class="mainSymbol">F</div><div class="secondarySymbol">φ</div></div>
      <div class="col keycap" v-on:click="keyClick('g')"><div class="mainSymbol">G</div><div class="secondarySymbol">γ</div></div>
      <div class="col keycap" v-on:click="keyClick('h')"><div class="mainSymbol">H</div><div class="secondarySymbol">η</div></div>
      <div class="col keycap" v-on:click="keyClick('j')"><div class="mainSymbol">J</div><div class="secondarySymbol">ξ</div></div>
      <div class="col keycap" v-on:click="keyClick('k')"><div class="mainSymbol">K</div><div class="secondarySymbol">κ</div></div>
      <div class="col keycap" v-on:click="keyClick('l')"><div class="mainSymbol">L</div><div class="secondarySymbol">λ</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">

      <div class="col keycap" v-on:click="keyClick('z')"><div class="mainSymbol">Z</div><div class="secondarySymbol">ζ</div></div>
      <div class="col keycap" v-on:click="keyClick('x')"><div class="mainSymbol">X</div><div class="secondarySymbol">χ</div></div>
      <div class="col keycap" v-on:click="keyClick('c')"><div class="mainSymbol">C</div><div class="secondarySymbol">ψ</div></div>
      <div class="col keycap" v-on:click="keyClick('v')"><div class="mainSymbol">V</div><div class="secondarySymbol">ω</div></div>
      <div class="col keycap" v-on:click="keyClick('b')"><div class="mainSymbol">B</div><div class="secondarySymbol">β</div></div>
      <div class="col keycap" v-on:click="keyClick('n')"><div class="mainSymbol">N</div><div class="secondarySymbol">ν</div></div>
      <div class="col keycap" v-on:click="keyClick('m')"><div class="mainSymbol">M</div><div class="secondarySymbol">μ</div></div>
      <div class="col keycap" v-on:click="keyClick('back')"><div class="mainSymbol">⌫</div><div class="secondarySymbol">back</div></div>

    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap" v-on:click="keyClick('ctrl')"><div class="mainSymbol">^</div><div class="secondarySymbol">ctrl</div></div>
      <div class="col keycap" v-on:click="keyClick('space')"><div class="mainSymbol">_</div><div class="secondarySymbol">space</div></div>
      <div class="col keycap" v-on:click="keyClick('left')"><div class="mainSymbol">←</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('right')"><div class="mainSymbol">→</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('up')"><div class="mainSymbol">↑</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('down')"><div class="mainSymbol">↓</div><div class="secondarySymbol"></div></div>
      <div class="col keycap" v-on:click="keyClick('enter')"><div class="mainSymbol">↵</div><div class="secondarySymbol">enter</div></div>
    </div>
  </div>
  <div class="keyboard" v-if="keyboardType ==5">
  <!-- keys - խվէրդեըիոպաստֆկհճքլզցգւբնմ -->

    <div class="row keyboardSmallRow justify-content-center">
      <div class="col keycap-sm"><div class="mainSymbol-sm">1</div><div class="secondarySymbol-sm">!</div></div>
      <div class="col keycap-sm"><div class="mainSymbol-sm">2</div><div class="secondarySymbol-sm">@</div></div>
      <div class="col keycap-sm"><div class="mainSymbol-sm">3</div><div class="secondarySymbol-sm">#</div></div>
      <div class="col keycap-sm"><div class="mainSymbol-sm">4</div><div class="secondarySymbol-sm">$</div></div>
      <div class="col keycap-sm"><div class="mainSymbol-sm">5</div><div class="secondarySymbol-sm">%</div></div>
      <div class="col keycap-sm"><div class="mainSymbol-sm">6</div><div class="secondarySymbol-sm">^</div></div>
      <div class="col keycap-sm"><div class="mainSymbol-sm">7</div><div class="secondarySymbol-sm">&</div></div>
      <div class="col keycap-sm"><div class="mainSymbol-sm">8</div><div class="secondarySymbol-sm">*</div></div>
      <div class="col keycap-sm"><div class="mainSymbol-sm">9</div><div class="secondarySymbol-sm">(</div></div>
      <div class="col keycap-sm"><div class="mainSymbol-sm">0</div><div class="secondarySymbol-sm">)</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap"><div class="mainSymbol">Q</div><div class="secondarySymbol">խ</div></div>
      <div class="col keycap"><div class="mainSymbol">W</div><div class="secondarySymbol">վ</div></div>
      <div class="col keycap"><div class="mainSymbol">E</div><div class="secondarySymbol">ե</div></div>
      <div class="col keycap"><div class="mainSymbol">R</div><div class="secondarySymbol">ր</div></div>
      <div class="col keycap"><div class="mainSymbol">T</div><div class="secondarySymbol">տ</div></div>
      <div class="col keycap"><div class="mainSymbol">Y</div><div class="secondarySymbol">եմ</div></div>
      <div class="col keycap"><div class="mainSymbol">U</div><div class="secondarySymbol">յ</div></div>
      <div class="col keycap"><div class="mainSymbol">I</div><div class="secondarySymbol">ի</div></div>
      <div class="col keycap"><div class="mainSymbol">O</div><div class="secondarySymbol">ո</div></div>
      <div class="col keycap"><div class="mainSymbol">P</div><div class="secondarySymbol">պ</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap"><div class="mainSymbol">A</div><div class="secondarySymbol">ա</div></div>
      <div class="col keycap"><div class="mainSymbol">S</div><div class="secondarySymbol">ս</div></div>
      <div class="col keycap"><div class="mainSymbol">D</div><div class="secondarySymbol">դ</div></div>
      <div class="col keycap"><div class="mainSymbol">F</div><div class="secondarySymbol">եր</div></div>
      <div class="col keycap"><div class="mainSymbol">G</div><div class="secondarySymbol">գ</div></div>
      <div class="col keycap"><div class="mainSymbol">H</div><div class="secondarySymbol">հ</div></div>
      <div class="col keycap"><div class="mainSymbol">J</div><div class="secondarySymbol">յա</div></div>
      <div class="col keycap"><div class="mainSymbol">K</div><div class="secondarySymbol">կ</div></div>
      <div class="col keycap"><div class="mainSymbol">L</div><div class="secondarySymbol">լ</div></div>
    </div>
    <div class="row keyboardRow justify-content-center">
      <div class="col keycap"><div class="mainSymbol">Z</div><div class="secondarySymbol">զ</div></div>
      <div class="col keycap"><div class="mainSymbol">X</div><div class="secondarySymbol">է</div></div>
      <div class="col keycap"><div class="mainSymbol">C</div><div class="secondarySymbol">ը</div></div>
      <div class="col keycap"><div class="mainSymbol">V</div><div class="secondarySymbol">թ</div></div>
      <div class="col keycap"><div class="mainSymbol">B</div><div class="secondarySymbol">բ</div></div>
      <div class="col keycap"><div class="mainSymbol">N</div><div class="secondarySymbol">ն</div></div>
      <div class="col keycap"><div class="mainSymbol">M</div><div class="secondarySymbol">մ</div></div>
      <div class="col keycap"><div class="mainSymbol">⌫</div><div class="secondarySymbol">back</div></div>
    </div>

    <div class="row keyboardRow justify-content-center">
      <div class="col keycap"><div class="mainSymbol">^</div><div class="secondarySymbol">ctrl</div></div>
      <div class="col keycap"><div class="mainSymbol">←</div><div class="secondarySymbol"></div></div>
      <div class="col keycap"><div class="mainSymbol">→</div><div class="secondarySymbol"></div></div>
      <div class="col keycap"><div class="mainSymbol">↑</div><div class="secondarySymbol"></div></div>
      <div class="col keycap"><div class="mainSymbol">↓</div><div class="secondarySymbol"></div></div>
      <div class="col keycap"><div class="mainSymbol">_</div><div class="secondarySymbol">space</div></div>
      <div class="col keycap"><div class="mainSymbol">↵</div><div class="secondarySymbol">enter</div></div>
    </div>
  
  </div>
  </div>
</div>
</template>

<script>
import TerminalEmulator from './components/TerminalEmulator.vue';

export default {
  name: 'App',
  components: {
    TerminalEmulator
},
  data() {
    return {
      currentApp: 'terminal',
      editorFile: null,
      terminalFontColor: '#ffffff',
      terminalBackgroundColor: '#000000',
      keyboardType: 1,
      keyboardLayout: 'none',
      backgroundColor: '#000000',
      deviceColor: '#000000',
      deviceRadius: '0px',
      keycapRadius: '0px',
      numKeycapRadius: '0px',
    }
  },
  mounted() {

    this.setBodyRandomColor();
    this.setRandomKeyboardLayout();
    this.setRandomDeviceColor();
    this.setRandomDeviceRadius();
    this.setRandomKeycapRadius();
    this.setRandomKeycapRadiusSmall();

    let newObject = {
      "Background Color": this.backgroundColor,
      "Device Color": this.deviceColor,
      "Device Radius": this.deviceRadius,
      "Keys Radius": this.keycapRadius,
      "Numbered Keys Radius": this.numKeycapRadius,
      "Keyboard Layout": this.keyboardLayout
    };
    window.$fxhashFeatures = {...window.$fxhashFeatures, ...newObject};

    window.isFxpreview = true;
  },
  methods: {
    setRandomDeviceColor(){
      let colors = ['#6d8094', '#d09d4e', '#C0A1E0', '#82A7D6', "#aa6f73", "#66545E", '#f5f5f5'];
      let color = colors[this.getRand(0, colors.length - 1)];
      this.$refs.device.style.backgroundColor = color;
      this.deviceColor = color;
    },
    setRandomKeycapRadius(){
      let radii = ['2px', '5px', '10px', '15px', '16px', '18px'];
      let radius = radii[this.getRand(0, radii.length - 1)];
      let keys = document.getElementsByClassName('keycap');
      for(let i = 0; i < keys.length; i++){
        keys[i].style.borderRadius = radius;
      }
      this.keycapRadius = radius;
    },
    setRandomKeycapRadiusSmall(){
      let radii = ['2px', '5px', '10px', '15px', '16px', '18px'];
      let radius = radii[this.getRand(0, radii.length - 1)];
      let smallKeys = document.getElementsByClassName('keycap-sm');
      for(let i = 0; i < smallKeys.length; i++){
        smallKeys[i].style.borderRadius = radius;
      }
      this.numKeycapRadius = radius;
    },
    setRandomDeviceRadius(){
      let radii = ['5px', '10px', '15px', '16px', '18px'];
      let radius = radii[this.getRand(0, radii.length - 1)];
      this.$refs.device.style.borderRadius = radius;
      this.deviceRadius = radius;
    },
    setRandomKeyboardLayout(){
      let keyboardTypes = [1,2,3,4];
      let keyboardType = keyboardTypes[this.getRand(0, keyboardTypes.length - 1)];
      this.keyboardType = keyboardType;

      switch(this.keyboardType){
        case 1:
          this.keyboardLayout = "Cyrillic"
          break;
        case 2:
          this.keyboardLayout = "Japanese"
          break;
        case 3:
          this.keyboardLayout = "Korean"
          break;
        case 4:
          this.keyboardLayout = "Greek"
          break;
      }
    },
    setBodyRandomColor(){
      let colors = ['#6d8094', '#d09d4e', '#C0A1E0', '#b7dc87', '#82A7D6', "#aa6f73", "#66545E", "#FFDAE0"];
      let color = colors[this.getRand(0, colors.length - 1)];
      document.body.style.backgroundColor = color;
      this.backgroundColor = color;
    },
    calcHash(string){
      var hash = 0, i, chr;
      if (string.length === 0) return hash;
      for (i = 0; i < string.length; i++) {
        chr   = string.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0;
      }
      return hash;
    },
    keyClick(key){
      this.$refs.terminalEmulator.keyClick(key);
    },
    getRand(min, max) {
      let value = Math.round(window.fxrand() * (max - min) + min);
      return value;
    },
    setFeatures(smiley, termFColor, termBColor, screenRadius){
      
      window.$fxhashFeatures = {
        "Smiley Face": smiley,
        "Terminal Font Color": termFColor,
        "Terminal Background Color": termBColor,
        "Screen Radius": screenRadius,
      }
    }
  }
}
</script>

<style>

/* dotgothic16-regular - japanese */
@font-face {
  font-family: 'DotGothic16';
  font-style: normal;
  font-weight: 400;
  src: url('fonts/dotgothic16-v15-japanese-regular.eot'); /* IE9 Compat Modes */
  src: local(''),
       url('fonts/dotgothic16-v15-japanese-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('fonts/dotgothic16-v15-japanese-regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('fonts/dotgothic16-v15-japanese-regular.woff') format('woff'), /* Modern Browsers */
       url('fonts/dotgothic16-v15-japanese-regular.ttf') format('truetype'), /* Safari, Android, iOS */
       url('fonts/dotgothic16-v15-japanese-regular.svg#DotGothic16') format('svg'); /* Legacy iOS */
}

/* press-start-2p-regular - latin_greek_cyrillic-ext_cyrillic */
@font-face {
  font-family: 'Press Start 2P';
  font-style: normal;
  font-weight: 400;
  src: url('fonts/press-start-2p-v14-latin_greek_cyrillic-ext_cyrillic-regular.eot'); /* IE9 Compat Modes */
  src: local(''),
       url('fonts/press-start-2p-v14-latin_greek_cyrillic-ext_cyrillic-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('fonts/press-start-2p-v14-latin_greek_cyrillic-ext_cyrillic-regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('fonts/press-start-2p-v14-latin_greek_cyrillic-ext_cyrillic-regular.woff') format('woff'), /* Modern Browsers */
       url('fonts/press-start-2p-v14-latin_greek_cyrillic-ext_cyrillic-regular.ttf') format('truetype'), /* Safari, Android, iOS */
       url('fonts/press-start-2p-v14-latin_greek_cyrillic-ext_cyrillic-regular.svg#PressStart2P') format('svg'); /* Legacy iOS */
}
html{
  height: 100%;
  width: 100%;
}

body{
  background-color: rgb(255, 255, 255);
  width: 100%;
  height: 100%;
  padding: 1rem;
  font-size: 10%;
}
#app{
  height: 100%;
}
.col {
  overflow-wrap: break-word;
}
.device{
  width: 100%;
  height: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-radius: 16px;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -0.5rem 0px inset;
}
.keyboard{
  width: 100%;
  height: 100%;
  padding-bottom: 1rem;
  text-align: center;
}
.keyboardContainer{
  height: 45%;
}
.keyboardSmallRow{
  height: 15%;
  margin: 0.5rem;
}
.keyboardRow{
  height: 20%;
  margin: 0.2rem;
}
.keycap{
  height: 100%;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  color: #564a3e;
  cursor: pointer;
  margin: 0.2rem;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  font-family: 'Press Start 2P', 'DotGothic16', monospace;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -0.2rem 0px inset;
}
.keycap:focus{
  outline: none;
}
.keycap-sm{
  height: 100%;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  margin: 0.2rem;
  color: #564a3e;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  font-family: 'Press Start 2P', 'DotGothic16', monospace;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -0.2rem 0px inset;
}
.keycap-sm:focus{
  outline: none;
}
.mainSymbol-sm{
  font-size: 0.5rem;
  text-align: left;
  padding-top: 0.2rem;
}
.secondarySymbol-sm{
  font-size: 0.4rem;
  text-align: right;
}
.mainSymbol{
  padding-top: 30%;
  font-size: 0.5rem;
  text-align: left;
}
.secondarySymbol{
  font-size: 0.5rem;
  text-align: right;
}
.spacer{
  text-align: center;
  font-size: 1rem;
  font-weight: bold;
  height: 0%;
  color: #FCE8A4;
  vertical-align: middle;
  font-family: 'Press Start 2P', monospace;
}
.screen{
  height: 50%;
}
.consoleWindow{
  width: 100%;
  height: 100%;
  border: 0.2rem solid rgb(220, 220, 220);
  border-radius: 16px;
  overflow: scroll;
  font-family: 'Press Start 2P', monospace;
  padding: 1rem;
  line-height: 1.5;
  background-color: #000000;
  color: #FFC000;
  font-size: 0.5rem;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
}
.consoleWindow input {
  border: none;
  display: inline;
  font-family: inherit;
  font-size: inherit;
  padding: none;
  width: auto;
  background-color: transparent;
  color: inherit;
}
.consoleInput{
  opacity:0;
  filter:alpha(opacity=0);
}
</style>
